export const tableSelectSx = {
  margin: '-12px -8px',
  '& .MuiAutocomplete-hasPopupIcon .MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot': {
    paddingRight: '66px'
  },
  '& .MuiInputBase-root': {
    '&.MuiInputBase-adornedStart .bds-chip': {
      // maxWidth: 100,
      minHeight: 0,
      height: 30,
      borderRadius: 0,
      paddingLeft: 0,
      background: 'transparent',
      color: '#000',
      fontFamily: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
      '[data-icon-name]': {
        display: 'none'
      }
    }
  },
  '& .MuiInputBase-root, .MuiInputBase-root.MuiAutocomplete-inputRoot': {
    '.MuiBox-root': {
      minHeight: 0
    },
    '.label-item.text': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '31px'
    },
    backgroundColor: 'transparent',
    border: 'none',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
};

export const selectStyleProps = {
  lineHeight: '45px'
};
